export default __webpack_public_path__ + "static/media/common.ebc3abc6.jpg";